// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"316":"d2511f5a44f5f6da","504":"c2d3faf3b7338075","962":"7f451a8805967743"}[chunkId] + ".js";
};